module.exports = __webpack_public_path__ + "static/media/toolbar-q-hideable.7518c591.svg";